import { z } from 'zod';
import { ErrorResponseSchema, SuccessMessageSchema } from '@/schemas/common/base';
import { idValidator } from '@/schemas/common/validators';

/**
 * PUT /api/chat/[id]/read
 * Marks a chat as read (resets unread count for the user)
 */

// Request parameter schema
export const ChatMarkReadParamSchema = z.object({
  id: idValidator,
});

export type ChatMarkReadParam = z.infer<typeof ChatMarkReadParamSchema>;

// Response schema using discriminated union
export const ChatMarkReadResponseSchema = z.discriminatedUnion('success', [
  SuccessMessageSchema,
  ErrorResponseSchema,
]);

export type ChatMarkReadResponse = z.infer<typeof ChatMarkReadResponseSchema>;
